import '.d7{font-size:1.125rem;}.ssr-plugin'
import '.g3{line-height:1.75rem;}.ssr-plugin'
import '.d2{text-decoration:none;}.ssr-plugin'
import '.eo{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="d7 g3"
    >
      {translations.privacySubtitle}{' '}
      <a className="d2 eo"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="d2 eo"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
